import api from '@/apis/di/budgetProvideAPI';
import Crud from '@/stores/crudBaseCache.js';
var crud = new Crud('budgetProvide', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_provide',
    field: {
      key: 'budget_provide_id',
      code: 'budget_provide_code',
      name: 'budget_provide_name',
      quickFollow: 'inactive', // thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
